import api from '../api';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import FindPasswordModal from '../Components/FindPasswordModal';
import { GoogleLogin } from '@react-oauth/google';
import Header from '../Components/Header';

const Login = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [errors, setErrors] = useState({
    email: '',
    password: ''
  });

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePassword = (password) => {
    const hasNumber = /\d/.test(password);
    const hasLetter = /[a-zA-Z]/.test(password);
    const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const isValidLength = password.length >= 8 && password.length <= 20;
    return hasNumber && hasLetter && hasSpecial && isValidLength;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let newErrors = { ...errors };

    if (name === 'email') {
      if (!validateEmail(value)) {
        newErrors.email = '이메일 형식이 올바르지 않습니다.';
      } else {
        newErrors.email = '';
      }
    }

    if (name === 'password') {
      if (!validatePassword(value)) {
        newErrors.password = '영문, 숫자, 특수문자를 조합한 8~20자로 입력하세요.';
      } else {
        newErrors.password = '';
      }
    }

    setErrors(newErrors);
  };

  // 쿠키 가져오기
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    const referralCode = getCookie('referral_code'); // 추천인 쿠키
    
    try {
      const response = await api.post('users/auth/google/', {
        credential: credentialResponse.credential,
        referral_code: referralCode
      });

      navigate('/');
    } catch (error) {
      if (error.response) {
        console.error('인증 실패:', error.response.data);
        alert(error.response.data.message || '인증에 실패했습니다.');
      } else if (error.request) {
        console.error('서버 응답 없음:', error.request);
        alert('서버와의 통신에 실패했습니다.');
      } else {
        console.error('요청 오류:', error.message);
        alert('요청 중 오류가 발생했습니다.');
      }
    }
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(formData.email)) {
      setErrors(prev => ({ ...prev, email: '이메일 형식이 올바르지 않습니다.' }));
      return;
    }

    if (!validatePassword(formData.password)) {
      setErrors(prev => ({ ...prev, password: '영문, 숫자, 특수문자를 조합한 8~20자로 입력하세요.' }));
      return;
    }

    try {
      console.log(123)
      const response = await api.post('users/auth/login/', formData);

      navigate('/');

    } catch (error) {
      if (error.response) {
        console.error('인증 실패:', error.response.data);
        setErrors(prev => ({ ...prev, password: error.response.data.message || '인증에 실패했습니다.' }));
        
      } else if (error.request) {
        console.error('서버 응답 없음:', error.request);
        alert('서버와의 통신에 실패했습니다.');
      } else {
        console.error('요청 오류:', error.message);
        alert('요청 중 오류가 발생했습니다.');
      }
    }
  };

  return (
    <div className="bg-white">
      <Header />
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-full max-w-md px-6 py-8">
        <h1 className="text-2xl font-bold text-center mb-8">
          <Link to="/">SWICHUP</Link>
        </h1>
        <p className="text-center mb-8">
          회원이 아니신가요? <Link to="/signup" className="text-blue-600 hover:text-blue-800">회원가입 하기</Link>
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="이메일"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {errors.email && <p className="mt-1 text-sm text-red-500">{errors.email}</p>}
          </div>

          <div>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="비밀번호"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {errors.password && <p className="mt-1 text-sm text-red-500">{errors.password}</p>}
          </div>

          <button
            type="submit"
            className="w-full py-2 bg-blue-600 text-white rounded-md font-semibold hover:bg-blue-700 transition duration-200"
          >
            로그인 하기
          </button>
        </form>

        <div className="mt-4">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => {
              console.error('Login Failed');
              alert('구글 로그인에 실패했습니다.');
            }}
            text="구글로 로그인 하기"
            useOneTap={false}
            type="standard"  // standard 타입 사용
            theme="outline"  // outline 테마 사용
            shape="rectangular"  // 사각형 모양
            width="100%"
            locale="ko"
    
          />
        </div>

        <div className="text-center mt-6">
          <button
            onClick={handleForgotPassword}
            className="text-gray-600 hover:text-gray-800"
          >
            비밀번호 찾기
          </button>
        </div>
        {isModalOpen && (
          <FindPasswordModal onClose={() => setIsModalOpen(false)} />
        )}
      </div>
    </div>
    </div>
  );
};

export default Login;